/**
 * LA BELLA SCELTA — script principale del tema Shopify
 * Il carrello usa il form nativo di Shopify ({% form 'cart' %} / {% form 'product' %}),
 * quindi qui gestiamo solo interazioni di interfaccia: menu mobile, galleria,
 * tab prodotto e selettore quantità. Nessuna dipendenza esterna.
 */

(function () {
  "use strict";

  /* ------------------------------------------------------------------ */
  /* 1. Menu di navigazione mobile                                       */
  /* ------------------------------------------------------------------ */
  function initNavDropdown() {
    var dropdowns = document.querySelectorAll("[data-nav-dropdown]");
    if (!dropdowns.length) return;
    document.addEventListener("click", function (e) {
      dropdowns.forEach(function (d) {
        if (d.open && !d.contains(e.target)) d.removeAttribute("open");
      });
    });
    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      dropdowns.forEach(function (d) { d.removeAttribute("open"); });
    });
  }

  function initHeroSlider() {
    var hero = document.querySelector("[data-hero-slider]");
    if (!hero) return;
    var slides = hero.querySelectorAll(".hero-slide");
    var dots = hero.querySelectorAll("[data-hero-dot]");
    if (slides.length < 2) return;
    var interval = (parseInt(hero.getAttribute("data-interval"), 10) || 10) * 1000;
    var current = 0;
    var timer = null;
    function show(i) {
      slides[current].classList.remove("is-active");
      if (dots[current]) dots[current].classList.remove("is-active");
      current = (i + slides.length) % slides.length;
      slides[current].classList.add("is-active");
      if (dots[current]) dots[current].classList.add("is-active");
    }
    function start() {
      if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      stop();
      timer = setInterval(function () { show(current + 1); }, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    dots.forEach(function (dot) {
      dot.addEventListener("click", function () {
        show(parseInt(dot.getAttribute("data-hero-dot"), 10));
        start();
      });
    });
    document.addEventListener("visibilitychange", function () {
      if (document.hidden) stop(); else start();
    });
    start();
  }

  function initMobileNav() {
    var header = document.querySelector(".site-header");
    var toggle = document.querySelector(".nav-toggle");
    if (!header || !toggle) return;

    toggle.addEventListener("click", function () {
      var isOpen = header.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", String(isOpen));
    });
  }

  /* ------------------------------------------------------------------ */
  /* 2. Feedback visivo sul bottone "Aggiungi al carrello"                */
  /*    Il submit del form resta quello nativo di Shopify (POST /cart/add) */
  /* ------------------------------------------------------------------ */
  function initAddToCartFeedback() {
    document.querySelectorAll("[data-add-to-cart]").forEach(function (btn) {
      btn.closest("form").addEventListener("submit", function () {
        btn.disabled = true;
        btn.dataset.originalText = btn.textContent;
        btn.textContent = "Aggiunta in corso…";
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* 3. Selettore quantita' (pagina prodotto e carrello)                  */
  /* ------------------------------------------------------------------ */
  function initQuantitySelectors() {
    document.querySelectorAll("[data-qty-selector]").forEach(function (wrapper) {
      var input = wrapper.querySelector("[data-qty-input]");
      if (!input) return;
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 99;

      wrapper.querySelectorAll("[data-qty-step]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var step = parseInt(btn.getAttribute("data-qty-step"), 10);
          var value = parseInt(input.value, 10) || min;
          value = Math.min(max, Math.max(min, value + step));
          input.value = String(value);
        });
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* 4. Galleria immagini prodotto                                       */
  /* ------------------------------------------------------------------ */
  function initGallery() {
    var main = document.querySelector("[data-gallery-main]");
    var thumbs = document.querySelectorAll("[data-gallery-thumb]");
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var newSrc = thumb.getAttribute("data-gallery-thumb");
        main.removeAttribute("srcset");
        main.removeAttribute("sizes");
        main.setAttribute("src", newSrc);
        thumbs.forEach(function (t) { t.classList.remove("is-active"); });
        thumb.classList.add("is-active");
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* 5. Selettore varianti: sincronizza le select visibili con il         */
  /*    campo nascosto "id" richiesto dal form { % form 'product' % }    */
  /* ------------------------------------------------------------------ */
  function initVariantSelectors() {
    var variantSelect = document.querySelector("[data-variant-select]");
    var optionSelects = document.querySelectorAll(".pd-options select");
    if (!variantSelect || !optionSelects.length) return;

    var mainImage = document.querySelector("[data-gallery-main]");
    var thumbs = document.querySelectorAll("[data-gallery-thumb]");
    var variantImagesEl = document.querySelector("[data-variant-images]");
    var variantImages = [];
    if (variantImagesEl) {
      try { variantImages = JSON.parse(variantImagesEl.textContent); } catch (e) { variantImages = []; }
    }

    function updateImageForVariant(variantId) {
      if (!mainImage) return;
      var match = variantImages.filter(function (v) { return v.id === variantId && v.image; })[0];
      if (!match) return; // nessuna immagine assegnata a questa variante: lascia l'immagine attuale
      mainImage.removeAttribute("srcset");
      mainImage.removeAttribute("sizes");
      mainImage.setAttribute("src", match.image);
      thumbs.forEach(function (t) {
        var isMatch = t.getAttribute("data-gallery-thumb") === match.image;
        t.classList.toggle("is-active", isMatch);
      });
    }

    // Approccio semplice: se il prodotto ha una sola combinazione di opzioni
    // visibile, la select nascosta viene aggiornata trovando l'option il cui
    // testo contiene tutti i valori scelti. Per progetti con molte varianti,
    // valuta l'uso della sezione "main-product" nativa di Shopify OS 2.0.
    function syncVariant() {
      var chosen = Array.prototype.map.call(optionSelects, function (s) { return s.value; });
      var options = variantSelect.querySelectorAll("option");
      options.forEach(function (opt) {
        var matchesAll = chosen.every(function (val) { return opt.textContent.indexOf(val) !== -1; });
        if (matchesAll) {
          variantSelect.value = opt.value;
          updateImageForVariant(opt.value);
        }
      });
    }

    optionSelects.forEach(function (select) {
      select.addEventListener("change", syncVariant);
    });
  }

  /* ------------------------------------------------------------------ */
  /* 6. Tab di dettaglio prodotto (descrizione / spedizione / recensioni) */
  /* ------------------------------------------------------------------ */
  function initTabs() {
    var tabButtons = document.querySelectorAll("[data-tab-target]");
    if (!tabButtons.length) return;

    tabButtons.forEach(function (btn) {
      btn.addEventListener("click", function () {
        var targetId = btn.getAttribute("data-tab-target");

        tabButtons.forEach(function (b) {
          b.classList.remove("is-active");
          b.setAttribute("aria-selected", "false");
        });
        document.querySelectorAll("[data-tab-panel]").forEach(function (p) {
          p.classList.remove("is-active");
        });

        btn.classList.add("is-active");
        btn.setAttribute("aria-selected", "true");
        var panel = document.querySelector('[data-tab-panel="' + targetId + '"]');
        if (panel) panel.classList.add("is-active");
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Avvio                                                                */
  /* ------------------------------------------------------------------ */
  document.addEventListener("DOMContentLoaded", function () {
    initMobileNav();
    initNavDropdown();
    initHeroSlider();
    initAddToCartFeedback();
    initQuantitySelectors();
    initGallery();
    initVariantSelectors();
    initTabs();
  });
})();
